"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapViewSettingsUrlProvider = void 0;
var KeyedCollection_1 = require("../../helpers/KeyedCollection");
var jquery_1 = require("jquery");
var MapViewSettingsUrlProvider = /** @class */ (function () {
    function MapViewSettingsUrlProvider() {
        var _this = this;
        this.CENTER = "center";
        this.ZOOM = "zoom";
        this.BASELAYER = "baselayer";
        this.BASELAYERS = "baselayers";
        this.BASELAYERS_OFF = "baselayersoff";
        this.OVERLAYS = "overlays";
        this.OVERLAYS_OFF = "overlaysoff";
        this.OPACITY = "opacity";
        this.ACTIVEPANEL = "panel";
        this.BASELAYER_SLIDER_POSITION = "baselayersliderposition";
        this.getQueryString = function (settings) {
            var s = settings;
            var qs = "";
            if (s.centre) {
                qs += _this.CENTER + "=" + s.centre;
            }
            if (s.zoom) {
                qs += "&" + _this.ZOOM + "=" + s.zoom;
            }
            //if (s.baselayers) {
            //    qs += `&${this.BASELAYER}=${s.baselayers}`;
            //}
            //build baselayers
            if (s.baselayers.size > 0) {
                var on_1 = new Array();
                var off_1 = new Array();
                s.baselayers.forEach(function (value, key) {
                    if (value === true) {
                        on_1.push(key);
                    }
                    else {
                        off_1.push(key);
                    }
                });
                if (on_1.length > 0) {
                    qs += "&" + _this.BASELAYERS + "=" + on_1.join(",");
                }
                if (off_1.length > 0) {
                    qs += "&" + _this.BASELAYERS_OFF + "=" + off_1.join(",");
                }
            }
            if (s.opacity) {
                qs += "&" + _this.OPACITY + "=" + s.opacity;
            }
            if (s.activePanel) {
                qs += "&" + _this.ACTIVEPANEL + "=" + s.activePanel;
            }
            if (s.baseLayerSliderPosition) {
                qs += "&" + _this.BASELAYER_SLIDER_POSITION + "=" + s.baseLayerSliderPosition;
            }
            //build overlays
            if (s.overlays.size > 0) {
                var on_2 = new Array();
                var off_2 = new Array();
                s.overlays.forEach(function (value, key) {
                    if (value === true) {
                        on_2.push(key);
                    }
                    else {
                        off_2.push(key);
                    }
                });
                if (on_2.length > 0) {
                    qs += "&" + _this.OVERLAYS + "=" + on_2.join(",");
                }
                if (off_2.length > 0) {
                    qs += "&" + _this.OVERLAYS_OFF + "=" + off_2.join(",");
                }
            }
            return qs;
        };
        this.hasKey = function (key) {
            return _this._allUrlParams.ContainsKey(key);
        };
        this.value = function (key) {
            var item = _this._allUrlParams.Item(key);
            if (item !== null && typeof item !== "undefined") {
                return item.replace(/\s/g, '');
            }
            return "";
        };
        this.isEmpty = function (obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        };
        this._allUrlParams = this.getUrlParams();
    }
    MapViewSettingsUrlProvider.prototype.getSettings = function () {
        var s = {};
        //center
        if (this.hasKey(this.CENTER)) {
            var centre = this.value(this.CENTER).split(",");
            if (centre && centre.length == 2) {
                var x = parseFloat(centre[0]);
                var y = parseFloat(centre[1]);
                if (!isNaN(x) && !isNaN(y)) {
                    s.centre = [x, y];
                }
            }
        }
        //zoom
        if (this.hasKey(this.ZOOM)) {
            var zoom = this.value(this.ZOOM);
            if (zoom) {
                var z = parseInt(zoom);
                if (!isNaN(z)) {
                    s.zoom = z;
                }
            }
        }
        //baselayer - kept after baselayers was introduced so we didn't break any existing links
        if (this.hasKey(this.BASELAYER)) {
            var base = this.value(this.BASELAYER);
            if (base) {
                s.baselayers.set(base, true);
            }
        }
        //baselayers
        if (this.hasKey(this.BASELAYERS) || this.hasKey(this.BASELAYERS_OFF)) {
            var baselayers = this.value(this.BASELAYERS).split(",");
            var baselayersOff = this.value(this.BASELAYERS_OFF).split(",");
            if (baselayers || baselayersOff) {
                s.baselayers = new Map();
                if (baselayers) {
                    for (var i = 0; i < baselayers.length; i++) {
                        if (baselayers[i]) {
                            s.baselayers.set(baselayers[i], true);
                        }
                    }
                }
                if (baselayersOff) {
                    for (var i = 0; i < baselayersOff.length; i++) {
                        if (baselayersOff[i]) {
                            s.baselayers.set(baselayersOff[i], false);
                        }
                    }
                }
            }
        }
        //overlays
        if (this.hasKey(this.OVERLAYS) || this.hasKey(this.OVERLAYS_OFF)) {
            var overlays = this.value(this.OVERLAYS).split(",");
            var overlaysOff = this.value(this.OVERLAYS_OFF).split(",");
            if (overlays || overlaysOff) {
                s.overlays = new Map();
                if (overlays) {
                    for (var i = 0; i < overlays.length; i++) {
                        if (overlays[i]) {
                            s.overlays.set(overlays[i], true);
                        }
                    }
                }
                if (overlaysOff) {
                    for (var i = 0; i < overlaysOff.length; i++) {
                        if (overlaysOff[i]) {
                            s.overlays.set(overlaysOff[i], false);
                        }
                    }
                }
            }
        }
        //opacity
        if (this.hasKey(this.OPACITY)) {
            var opacity = this.value(this.OPACITY);
            if (opacity) {
                var o = parseFloat(opacity);
                if (!isNaN(o)) {
                    s.opacity = o;
                }
            }
        }
        //active panel
        if (this.hasKey(this.ACTIVEPANEL)) {
            var panel = this.value(this.ACTIVEPANEL);
            if (panel) {
                s.activePanel = panel;
            }
        }
        //baselayer slider position
        if (this.hasKey(this.BASELAYER_SLIDER_POSITION)) {
            var position = this.value(this.BASELAYER_SLIDER_POSITION);
            if (jquery_1.isNumeric(position)) {
                if (Number(position) > 0 && Number(position) < 1) {
                    s.baseLayerSliderPosition = Number(position);
                }
            }
        }
        //example structure
        //s = {
        //    "centre": [-425649.302412434, 7931999.1778468145],
        //    "zoom": 14,
        //    "baselayer": null,
        //    "overlays": {
        //        "Monuments": true,
        //        "ScheduledMonuments": false,
        //        "ListedBuildings": true,
        //        "Events": false
        //    },
        //    "opacity": 1,
        //    "activePanel": "overlays"
        //}
        if (console) {
            console.log("MapViewSettingUrlProvider: " + JSON.stringify(s));
        }
        if (this.isEmpty(s)) {
            s = null;
        }
        return s;
    };
    MapViewSettingsUrlProvider.prototype.getUrlParams = function () {
        // stuff after # is not part of query string, so get rid of it
        var queryString = window.location.search.slice(1).split('#')[0];
        var parameterCollection = new KeyedCollection_1.KeyedCollection();
        // if query string exists
        if (queryString) {
            var pArr = queryString.split('&');
            for (var i = 0; i < pArr.length; i++) {
                var nvp = pArr[i].split('=');
                var name_1 = decodeURIComponent(nvp[0]).toLowerCase();
                var value = typeof (nvp[1]) === "undefined" ? "" : decodeURIComponent(nvp[1]);
                var item = parameterCollection.Item(name_1);
                if (!item) {
                    item = parameterCollection.Add(name_1, value);
                }
            }
        }
        return parameterCollection;
    };
    return MapViewSettingsUrlProvider;
}());
exports.MapViewSettingsUrlProvider = MapViewSettingsUrlProvider;
//# sourceMappingURL=MapViewSettingsUrlProvider.js.map